/* eslint-disable import/prefer-default-export */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable no-unused-vars */
import React from 'react';
import CloseIcon from '@material-ui/icons/Close';
import AddTabIcon from 'assets/icons/add-tab.svg';
import EditIcon from '@material-ui/icons/Edit';
import {
  Share,
  Description,
  Folder,
  NoteAdd,
  CreateNewFolder,
  Publish,
  BorderColor,
  Today,
  Alarm,
  Delete,
  Forward
} from '@material-ui/icons';
import AssignmentIcon from '@material-ui/icons/Assignment';
import RenameIcon from 'assets/icons/rename-icon.svg';

export const MENUS = [
  {
    icon: <img src={AddTabIcon} alt='add-tab' />,
    label: 'New tab',
    action: 'new-tab',
  },
  {
    icon: <EditIcon style={{ color: '#4E5A71' }} />,
    label: 'Edit tab',
    action: 'edit-tab',
  },
];

export const TABS = [
  {
    label: 'Inspection',
    key: 'inspection',
  },
  {
    label: 'Testing',
    key: 'testing',
  },
  {
    label: 'Document',
    key: 'document',
  },
];

export const ToolbarActions = [
  {
    key: 'new-folder',
    label: 'New folder',
    icon: <CreateNewFolder />,
  },
  {
    key: 'upload',
    label: 'Upload file',
    icon: <NoteAdd />,
  },
  {
    key: 'share',
    label: 'Share',
    icon: <Share />,
  },
  {
    key: 'bulk-download',
    label: 'Bulk download',
    icon: (
      <Publish
        style={{
          transform: 'rotate(180deg)',
        }}
      />
    ),
  },
  {
    key: 'download',
    label: 'Download',
    icon: (
      <Publish
        style={{
          transform: 'rotate(180deg)',
        }}
      />
    ),
  },
  {
    key: 'move-to', 
    label: 'Move to', 
    icon: <Forward />, 
  },
  {
    key: 'rename',
    label: 'Rename',
    icon: <img src={RenameIcon} alt='rename' />,
  },
  {
    key: 'set-expiry-date',
    label: 'Set expiry date',
    icon: <Today />,
  },
  {
    key: 'set-reminder',
    label: 'Set Reminder',
    icon: <Alarm />,
  },
  {
    key: 'get-doc',
    label: 'Get DoC',
    icon: <AssignmentIcon />,
  },
  {
    key: 'delete',
    label: 'Delete',
    icon: <Delete />,
  },
];

export const Actions = {
  default: ['new-folder', 'upload', 'share', 'bulk-download'],
  singleFile: [
    'share',
    'download',
    'move-to', 
    'rename',
    'set-expiry-date',
    'set-reminder',
    'get-doc',
    'delete',
  ],
  multipleFilesOrFolder: ['share', 'download', 'move-to', 'get-doc', 'delete',],
};
